// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__-BarM","footer":"Form_footer__3_U9Y"};